const numberToWordMap: { [key: number]: string } = {
  1: 'One',
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five'
};

export const convertNumberToWord = (number: number): string => numberToWordMap[number] || '';
